import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './app';
import { loadConfig } from './environment';

loadConfig()
    .then(() => {
        const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
        root.render(<App />);
    })
    .catch((error) => {
        console.error('Failed to load config:', error);
        const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
        root.render(<App />);
    });
